
const menu = [
    {
        id: 2,
        title: 'Tuna Tataki',
        category: 'entrees',
        price: 15,
        img:require('../../assets/products/tuna.jpg'),
        desc:`The tuna is seared briefly and then served with a spicy sauce made from ginger, soy sauce and lime.`,
    },
    {
        id: 3,
        title: 'Ceviche',
        category: 'entrees',
        price: 15,
        img:require('../../assets/products/ceviche.jpg'),
        desc:`Ceviche is a traditional Latin American dish featuring raw seafood that is marinated in lime or lemon juice. This ceviche draws inspiration from Japanese food.`,
    },
    {
        id: 4,
        title: 'Gyoza',
        category: 'entrees',
        price: 8,
        img:require('../../assets/products/gyoza.jpg'),
        desc:`Our homemade gyoza. Juicy on the inside, a golden brown and crispy base.`,
    },
    {
        id: 1,
        title: 'Shrimp and Veggie Tempura',
        category: 'entrees',
        price: 12,
        img: require('../../assets/products/tempura.jpg'),
        desc:`The best seasonal tempura mixed vegetables and shrimp prepared Goya style.`,
    },
    {
        id: 5,
        title: 'Edamame',
        category: 'entrees',
        price: 7,
        img:require('../../assets/products/edamame.jpg'),
        desc:`Fried edamame with hot sauce.`,
    },
    {
        id: 6,
        title: 'California Roll',
        category: 'rolls',
        price: 15,
        img:require('../../assets/products/california.jpg'),
        desc:`Salmon, avocado, cucumber, philadelphia and roe.`,
    },
    {
        id: 7,
        title: 'Sake Avocado',
        category: 'rolls',
        price: 13,
        img:require('../../assets/products/avocado.jpg'),
        desc:`Salmon, avocado and cream Cheese.`,
    },
    {
        id: 8,
        title: 'Tiger Hot Maki',
        category: 'rolls',
        price: 12,
        img:require('../../assets/products/tiger.jpg'),
        desc:`Cream cheese, cucumber, wakame, ginger, tiger prawn, salmon.`,
    },
    {
        id: 9,
        title: 'Salmon Tartare',
        category: 'entrees',
        price: 15,
        img:require('../../assets/products/tartare.jpg'),
        desc:`Salmon tartare, avocado macerated in ponzu and kizami wasabi.`,
    },
    {
        id: 10,
        title: 'Jambo maki',
        category: 'rolls',
        price: 12,
        img:require('../../assets/products/jambo.jpg'),
        desc:`Tiger prawn, salmon, cucumber, avocado, cream cheese.`,
    },
    {
        id: 11,
        title: 'Maki Dragon',
        category: 'rolls',
        price: 12,
        img:require('../../assets/products/dragon.jpg'),
        desc:`Dragon Roll is a delicious maki topped with avocado.`,
    },
    {
        id: 12,
        title: 'Salmon Sashimi',
        category: 'sashimi',
        price: 9,
        img:require('../../assets/products/sashimi-salmon.jpg'),
        desc:`8 slices pf the best salmon sashimi.`,
    },
    {
        id: 13,
        title: 'Tuna Sashimi',
        category: 'sashimi',
        price: 10,
        img:require('../../assets/products/sashimi-tuna.jpg'),
        desc:`Salmon, avocado and cream Cheese.`,
    },
    {
        id: 14,
        title: 'Bonito Sashimi',
        category: 'sashimi',
        price: 11,
        img:require('../../assets/products/sashimi-bonito.jpg'),
        desc:`Cured bonito sashimi with shiso leaf, watercress and passion fruit ponzu.`,
    },
    {
        id: 15,
        title: 'Coke',
        category: 'drinks',
        price: 4,
        img:require('../../assets/products/coke.jpg'),
        desc:`Nothing like a cold coke, right?`,
    },
    {
        id: 16,
        title: 'Japonese Beer',
        category: 'drinks',
        price: 4,
        img:require('../../assets/products/beer.jpg'),
        desc:`The beer for all seasons.`,
    },
    {
        id: 17,
        title: 'Sake Bottle',
        category: 'drinks',
        price: 10,
        img:require('../../assets/products/sake.jpg'),
        desc:`Made from rice, water, koji and yeast.`,
    },
]

export default menu;